<div class="switcher">
  <div class="col-md-12 block switcher_content">
    <div
      class="switcher_content_step"
      [class.switcher_content_active]="isCompleteStep(0)"
      [class.switcher_content_current]="isCurrentStep(0)"
    >
      {{ 'MyProfile_GDPR_Title' | translate }}
    </div>
    <div
      class="switcher_content_step"
      [class.switcher_content_active]="isCompleteStep(1)"
      [class.switcher_content_current]="isCurrentStep(1)"
    >
      {{ 'MyProfile_YP_YourProfile' | translate }}
    </div>
    <div
      class="switcher_content_step"
      [class.switcher_content_active]="isCompleteStep(2)"
      [class.switcher_content_current]="isCurrentStep(2)"
      *ngIf="!isSSOUser"
    >
      {{ 'MyProfile_AS_AccountSecurity' | translate }}
    </div>
  </div>
</div>
